import { useEffect, useRef, useState } from 'react';
import { WindowContent, WindowHeader } from 'react95';
import styled from 'styled-components';
import DraggableComponent from '../DraggableComponent';
import WindowComponent from '../WindowComponent';
import WindowButton from '../buttons/WindowButton';
import './paintwindow.scss';

const Wrapper = styled.div`
  position: absolute;
  background: transparent;
`;

const PaintWindow = ({ displayTasks, displayingTask, setActiveTask, activeTask, indexingTasks, taskIndices, tasksVisibility, setTasksVisibility, setTaskSwitiching }) => {
  const task = 'paint';
  const [isDraggable, setIsDraggable] = useState(true);
  const initialPosition = window.innerWidth > 720 ? { x: 60, y: 20 } : { x: window.innerWidth * 0.02, y: 10 };
  const isOpen = displayTasks.has(task);
  const [hasOpened, setHasOpened] = useState(false);
  const frameRef = useRef(null);
  const [status, setStatus] = useState('loading');
  const [reloadKey, setReloadKey] = useState(0);
  const paintUrl = `${process.env.PUBLIC_URL}/jspaint/index.html`;

  useEffect(() => {
    if (isOpen) setHasOpened(true);
  }, [isOpen]);

  useEffect(() => {
    if (!hasOpened) return;
    setStatus('loading');
    const timeout = setTimeout(() => setStatus('error'), 15000);
    const handleReady = (event) => {
      if (event.origin !== window.location.origin || event.source !== frameRef.current?.contentWindow || event.data?.type !== 'portfolio-paint-ready') return;
      clearTimeout(timeout);
      setStatus('ready');
    };
    window.addEventListener('message', handleReady);
    return () => {
      clearTimeout(timeout);
      window.removeEventListener('message', handleReady);
    };
  }, [hasOpened, reloadKey]);

  return (
    <DraggableComponent task={task} initialPosition={initialPosition} setActiveTask={setActiveTask} indexingTasks={indexingTasks} isDraggable={isDraggable} setIsDraggable={setIsDraggable}>
    <Wrapper className="drag-paint" style={{zIndex: taskIndices[task], display: isOpen ? 'block' : 'none', visibility: tasksVisibility[task]}}>
    <WindowComponent task={task} setActiveTask={setActiveTask} indexingTasks={indexingTasks}>
      <strong className="cursor"><WindowHeader active={activeTask === task} className='window-title'>
        <span>Paint</span>
        <div className="buttons">
          <WindowButton purpose='minimise' tasksVisibility={tasksVisibility} task={task} setTasksVisibility={setTasksVisibility} setActiveTask={setActiveTask} setTaskSwitiching={setTaskSwitiching} setIsDraggable={setIsDraggable} />
          <WindowButton purpose='close' task={task} setActiveTask={setActiveTask} displayingTask={displayingTask} setIsDraggable={setIsDraggable} />
        </div>
      </WindowHeader></strong>
      <WindowContent className='window-content'>
        <div className="paint-screen">
          {hasOpened && <iframe
            key={reloadKey}
            ref={frameRef}
            title="jspaint"
            src={paintUrl}
            referrerPolicy="no-referrer"
            sandbox="allow-scripts allow-same-origin allow-modals allow-popups allow-popups-to-escape-sandbox allow-downloads"
          />}
          {status !== 'ready' && <div className="paint-loading" role="status">
            <p>{status === 'loading' ? 'Carregando Paint…' : 'O Paint ainda não terminou de carregar.'}</p>
            {status === 'error' && <button onClick={() => setReloadKey((key) => key + 1)}>Tentar novamente</button>}
          </div>}
        </div>
        <p className="paint-footer">JS Paint · <a href={paintUrl} target="_blank" rel="noopener noreferrer">Abrir em outra aba ↗</a></p>
      </WindowContent>
    </WindowComponent>
  </Wrapper>
  </DraggableComponent>
  );
};

export default PaintWindow;
